import React, {FC} from 'react';
import Accordion from 'react-bootstrap/Accordion';

import styles from './FAQ.module.css';
import {Page} from '../../../state/types';
import {useState} from '../../../state/store';
import {config} from "../../../state/config";

type FQ = {
    question: string;
    answer: string | React.ReactElement;
};

const faqs: FQ[] = [
    {
        question: 'How do I find the IMEI of my smart device?',
        answer:
            'Your existing smart device IMEI number can be found by typing in *#06# in the smart device phone dialler on your device (or in your device settings). It should also be printed on the back of your device, on the box your smart device was shipped in or under the battery.',
    },
    {
        question: 'Does a cracked screen deem the smart device as in bad working condition?',
        answer: (
            <>
                Yes, if there is a crack on the smart device screen then we will deem it as falling into the bad working condition criteria, see our <a href="https://shop.samsung.com/ie/trade-in-terms-and-conditions" target="_blank">Terms & Conditions</a> for further details. We will still accept this smart device but the trade-in value will vary as per terms and conditions of the promotion
            </>
        ),
    },
    {
        question: 'What do I need to include with my trade-in device?',
        answer:
            'All we require is the smart device. We DO NOT need any charger or accessories however if you wish to dispose of these in a sustainable way then please feel free to send them with your smart device. Please ensure all sim, memory cards are removed. Please ensure there is no passcode or network / device lock turned on',
    },
    {
        question: 'When will I receive my welcome returns pack so I can send you my trade-in smart device?',
        answer: (
            <>
                As soon as you complete our online trade in process, we will send you out an email with details for returning you trade-in device. As soon as you receive this email follow the instructions contained inside and return your old smart device for evaluation.
            </>
        ),
    },
    {
        question: 'What happens if I exceed the 14 day returns period?',
        answer: (
            <>
                <a href="https://shop.samsung.com/ie/trade-in-terms-and-conditions" target="_blank">Terms & conditions</a> apply as per the promotion and the offer may have expired. If the promotion is still valid then you can still ship the smart device to us. The reward you have been quoted is valid for 14 days, the trade in value of your smart device could change after this period. .
            </>
        ),
    },
    {
        question: 'Do I use the returns pack that came with my new smart device?',
        answer:
            'No, please pack your device well and attach the shipping label that you received from MacroEV. DO NOT use the returns pack provided with your new device.',
    },
    {
        question: 'Common faults and issues that will deem your device as in bad working condition.',
        answer: (
            'Common faults on traded in devices are typically related to the display, like, screen burn, Pressure marks, scratches, Non-genuine screens / parts. However as per the promotional terms and conditions we will take Any Smart device in Any Condition during the promotional period. The condition of the smart device you are trading in will determine if any trade-in reward will be provided, you will still get the reward no matter the condition of the smart device you trade in with us.'
        ),
    },

    {
        question: 'If I can’t fully wipe my old smart device how can I be sure my data is safe?',
        answer: (
            <>
                <p>
                    We understand there may be sensitive or personal data on your device that you have been unable to remove. We run a full, secure data wipe service to remove all data from devices in accordance with the Data Protection Act*, so you can sell to us with peace of mind that all your personal data will be securely removed. If we receive a device with a SIM or Memory card enclosed it will be destroyed.
                </p>
                <p>* Devices which are beyond economical repair or cannot be physically data wiped will be recycled.</p>
            </>
        ),
    },
    {
        question: 'How can I see what stage my order is at?',
        answer: (
            <>
                Every order made with us is assigned an order number and you will receive regular email updates at each stage of the process. You may contact us directly at any stage by using the <a href={`#${Page.ContactUs}`}>Contact Us</a> form on our website
            </>
        ),
    },
    {
        question: 'iCloud Account Removal ?',
        answer: (
            <>
                <div className="flex flex-row">
                    <div className="w-50 align-self-center">
                        <p>
                            For Apple devices running iOS 7 or later
                        </p>
                        <p>
                            Signing out of your account on your device From your device Go to Settings. Next, tap on your name. Scroll to the bottom and tap on Sign Out Tap Sign Out again. If prompted, enter your Apple ID and password, and tap Turn Off. Switch OFF your device. The device must be offline before you can remove it from the Devices list.
                        </p>
                    </div>
                    <div className="w-50 flex justify-content-center">
                        <img src={`${config.publicUrl}/img/faq/faq1.png`}  className="p-8"/>
                    </div>
                </div>
                <div className="flex">
                  <div className="md:w-1/3"><hr/></div>  <div className="md:w-1/3 text-center">OR</div><div className="md:w-1/3"><hr/></div>
                </div>
                <div className="flex flex-row">
                    <div className="w-50 align-self-center">
                        <p>
                            Remove your device from your iCloud account at www.icloud.com
                        </p>
                        <p>
                            On a computer web browser, log in using your Apple ID and password at iCloud.com. 2. In Find Devices on iCloud.com, click All Devices, then select the device you want to remove. 3. Click on the device you want to remove then Click on Remove from Account to confirm
                        </p>
                    </div>
                    <div className="w-50 flex justify-content-center">
                        <img src={`${config.publicUrl}/img/faq/faq2.png`}  className="p-8"/>
                    </div>
                </div>
            </>
        ),
    }, {
        question: 'Account removal',
        answer: (
            <>
                <p>
                    Some mobiles may have a factory reset protection (FRP). To ensure your accounts are removed following a factory reset, please connect to the internet and navigate to your Settings.
                </p>
                <ol className="list-decimal">
                    <li>From Settings, tap Accounts</li>
                    <li>Select the account you wish to remove.</li>
                    <li>Tap your Email Address twice, then tap More or you can tap on the 3 Dots in the upper right corner.</li>
                    <li>Tap Remove Account. Tap Remove Account again when prompted.</li>
                    <li>Enter your password and then tap Remove Account.</li>
                </ol>
                <div className="flex justify-content-center">
                    <img src={`${config.publicUrl}/img/faq/faq3.png`}  className="p-8"/>
                </div>

            </>
        ),
    }, {
        question: 'Final things to do',
        answer: (
            <>

                <ul>
                    <li>Unless you selected that your phone does not work, please ensure the criteria below is checked.</li>
                    <li>You must ensure your phone is network unlocked before sending. Please contact your carrier for more information.</li>
                    <li>Remove any security PIN codes or other screen locks.</li>
                    <li>Remove any iCloud account from iOS devices or Samsung Reactivation Account Lock from Samsung devices.</li>
                    <li>Delete all personal files and information by performing a factory reset. Note: A factory reset will WIPE all data/personal data from the device.</li>
                </ul>

            </>
        ),
    }, {
        question: 'Packing your trade-in device',
        answer: (
            <>

                <ul>
                    <li>Prepare your device by removing any device covers and accessories such as sim cards.</li>
                    <li>Please pack your product carefully in suitable packaging - use a suitably sized box and filler, such as bubble wrap to secure your device for transit. Use packaging that doesn't bulge and is strong enough to protect the device. If you are returning the trade-in device in its original packaging, please ensure that there are no other labels attached to your package.</li>
                    <li>Note: Any damaged caused to your device during shipping is not the responsibility of MacroEV. Please ensure device is securely packaged to avoid any damage.</li>
                    <li>Cut the label along the dotted line. Affix the label securely to the front of the item you wish to send using clear tape, ensuring the label is clearly visible; do not apply tape over the barcoded area. Taping all sides down to ensure the shipping label won’t come off.</li>
                    <li>Bring your device to any An Post office for easy shipping. If you are unable to print the shipping label at home – show the barcode to a member of staff and they will print the label for you. Attach the shipping label securely to the device package.</li>
                </ul>

            </>
        ),
    },
];

const FAQ: FC = () => {
    const {page} = useState('page');

    if (page !== Page.FAQ) {
        return null;
    }

    return (
        <div className={`${styles.FAQ} container flex flex-col`} data-testid="FAQPage">
            <section>
                <div>
                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                </div>
            </section>
            <section className="mt-6 mb-10">
                <Accordion defaultActiveKey="0">
                    {faqs.map((faq, index) => (
                        <Accordion.Item eventKey={`${index}`} key={index}>
                            <Accordion.Header className={styles.Question}>{faq.question}</Accordion.Header>
                            <Accordion.Body className={styles.Answer}>{faq.answer}</Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </section>
        </div>
    );
};

export default FAQ;